import { FC } from 'react';
import { Breadcrumb, Card, PageHeader } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ProductForm from '../components/forms/product-form';

const ProductsFormRoute: FC = () => {
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  return (
    <>
      <PageHeader
        title="فرم محصول"
        style={{ padding: " 16px 0" }}
        onBack={() => navigate(-1)}
        />
      <Card >
        <ProductForm id={id} />
      </Card>
    </>
  );
}

export default ProductsFormRoute;
